"use client"

import * as React from "react"
import * as PopoverPrimitive from "@radix-ui/react-popover"

type DatePopoverProps = Omit<React.ComponentProps<typeof PopoverPrimitive.Root>, "modal">

function DatePopover(props: DatePopoverProps) {
  return <PopoverPrimitive.Root modal {...props} />
}

export { DatePopover }
